import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PageShell from "@/components/pages/PageShell";
import SupporterHero from "@/components/supporter/SupporterHero";
import Packages from "@/components/supporter/Packages";
import BusinessAreas from "@/components/supporter/BusinessAreas";
import SignupSection from "@/components/signup/SignupSection";
import { LaunchStrip } from "@/components/landing/PartnerBits";
import { Benefits, Audience } from "@/components/supporter/Benefits";
import { CityBand, Steps, SupporterFAQ, FinalCta } from "@/components/supporter/Sections";

const useHashScroll = () => {
  const { hash, key } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const go = () => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
    const ids = [setTimeout(go, 80), setTimeout(go, 900)];
    return () => ids.forEach(clearTimeout);
  }, [hash, key]);
};

export default function SupporterPage() {
  useHashScroll();
  return (
    <PageShell testId="supporter-page">
      <div className="space-y-24 md:space-y-32">
        <div className="space-y-14">
          <LaunchStrip testId="supporter-launch-strip" />
          <SupporterHero />
        </div>
        <Benefits />
        <Audience />
        <BusinessAreas />
        <Packages />
        <SignupSection />
        <CityBand />
        <Steps />
        <SupporterFAQ />
        <FinalCta />
      </div>
    </PageShell>
  );
}
